export enum SocialLoginMethodModel {
    POPUP = 'popup',
    REDIRECT = 'redirect',
}
